import React from 'react'

interface ProductResult {
  name: string
  url: string
  description: string
  vendor: string
  price?: string
  rating?: string
  image?: string
  images?: string[]
  scrapedTitle?: string
  scrapedPrice?: string
  scrapedRating?: string
}

interface ProductResultsProps {
  products: ProductResult[]
}

export function ProductResults({ products }: ProductResultsProps) {
  if (!products || products.length === 0) {
    return null
  }

  return (
    <div className="mt-4 p-4 bg-muted/30 rounded-lg border border-border">
      <h3 className="text-base font-semibold mb-3 text-foreground">Product Search Results</h3>
      <div className="space-y-2">
        {products.map((product, index) => (
          <a
            key={index}
            href={product.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block p-3 bg-background rounded-md border border-border hover:bg-accent hover:border-accent-foreground transition-colors group"
          >
            <div className="flex items-start gap-3">
              {/* Product Image */}
              {product.images && product.images.length > 0 && (
                <div className="flex-shrink-0">
                  <img
                    src={product.images[0]}
                    alt={product.scrapedTitle || product.name}
                    className="w-16 h-16 object-cover rounded-md border border-border"
                    onError={(e) => {
                      // Hide image if it fails to load
                      e.currentTarget.style.display = 'none';
                    }}
                  />
                </div>
              )}
              
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <h4 className="font-medium text-foreground group-hover:text-accent-foreground mb-1 truncate">
                      {product.scrapedTitle || product.name}
                    </h4>
                    <p className="text-sm text-muted-foreground line-clamp-2">
                      {product.description}
                    </p>
                    <div className="flex items-center gap-2 mt-1">
                      {product.scrapedPrice && (
                        <span className="text-sm font-medium text-green-600">
                          {product.scrapedPrice}
                        </span>
                      )}
                      {product.scrapedRating && (
                        <span className="text-xs text-muted-foreground">
                          ⭐ {product.scrapedRating}
                        </span>
                      )}
                      {!product.scrapedRating && product.rating && (
                        <span className="text-xs text-muted-foreground">
                          ⭐ {product.rating}
                        </span>
                      )}
                    </div>
                  </div>
                  <svg 
                    className="w-5 h-5 text-muted-foreground group-hover:text-accent-foreground flex-shrink-0 mt-0.5" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                  </svg>
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
      <p className="text-xs text-muted-foreground mt-3">
        * Affiliate links - we may earn a commission at no extra cost to you.
      </p>
    </div>
  )
}
